import { METRIC_SOURCE } from "./AddMetricSideSheet/metricOptions";

// Same node lookup as participant rows; empty slots stay as layout spacers.

function isTruthyFlag(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

function nodeHas(node, attribute) {
  return !!attribute && !!node && Object.prototype.hasOwnProperty.call(node, attribute);
}

function nodeValue(node, attribute) {
  if (!nodeHas(node, attribute)) return null;
  return node[attribute];
}

function nodeText(node, attribute) {
  if (!attribute) return "";
  const value = nodeValue(node, attribute);
  if (value == null) return "";
  return String(value);
}

export function toPreviewMetric(column, metric) {
  const node = metric ?? {};
  const isEarnings = column.metricSource === METRIC_SOURCE.EARNINGS;

  switch (column.componentType) {
    case "PROGRESS_BAR":
      return {
        progress: nodeValue(node, column.informMetricAttribute),
        rangeStartLabel: nodeText(node, column.rangeStartLabelAttribute),
        rangeEndLabel: nodeText(node, column.rangeEndLabelAttribute),
      };
    case "STATUS":
      return {
        met: isTruthyFlag(nodeValue(node, column.informMetricAttribute)),
        metLabel: nodeText(node, column.statusMetLabelAttribute),
        notMetLabel: nodeText(node, column.statusNotMetLabelAttribute),
      };
    default:
      return {
        // Earnings have no Inform value; NumberMetric supplies defaults.
        value: isEarnings ? null : nodeValue(node, column.informMetricAttribute),
        prefix: nodeText(node, column.prefixLabelAttribute),
        suffix: nodeText(node, column.suffixLabelAttribute),
        label: nodeText(node, column.labelAttribute),
      };
  }
}

export function toPreviewRows(rows, metric) {
  return (rows || []).map((row) => {
    const columns = row.columns || [];
    const slotCount = row.columnCount || columns.length;
    return {
      key: row.rowId,
      columns: Array.from({ length: slotCount }, (_, slotIndex) => {
        const column = columns.find((c) => c.slotIndex === slotIndex && !!c.componentType);
        return {
          key: slotIndex,
          componentType: column ? column.componentType : null,
          isEarnings: column?.metricSource === METRIC_SOURCE.EARNINGS,
          metric: column ? toPreviewMetric(column, metric) : null,
        };
      }),
    };
  });
}
